module.exports = __webpack_public_path__ + "images/ainmneacha-fearainn-idirnáisiúnaithe-mapa-áis-eoraip-afraic-thuaidh-1600w.webp";